import React from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import axios from "axios";

class MultiSelect extends React.Component {
  state = {
    data: [],
    opts: this.props.fieldValue ? this.props.fieldValue : []
  };

  componentWillMount() {
    if (this.props.data) {
      this.setState({ data: this.props.data});
    } else {
      this.buildData();
    }
  }

  buildData() {
    var that = this;

    axios({
      method: "get",
      url: that.props.url
    }).then(function(response) {
      that.setState({ data: response.data });
    });
  }

  newOpts = opts => {
    this.setState(
      {
        opts: opts
      },
      () => {
        this.props.newOptsCallback(opts);
      }
    );
  };

  render() {
    return (
      <div className={this.props.fieldClassName}>
        <div className="field multiselect-field">
          <div className="control">
            <div className="is-fullwidth">
              <div className="is-medium is-fullwidth">
                <Select
                  closeMenuOnSelect={true}
                  isMulti
                  onChange={e => this.newOpts(e)}
                  options={this.state.data.map(opt => ({
                    label: opt[this.props.selectLabel],
                    value: opt[this.props.selectKey]
                  }))}
                  placeholder={this.props.fieldPlaceholder}
                  aria-label={this.props.fieldPlaceholder || "Multi Select"}
                  removeSelected={true}
                  simpleValue
                  value={this.state.opts}
                  styles={{
                    placeholder: (provided) => ({
                      ...provided,
                      color: 'black'
                    })
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MultiSelect.propTypes = {
  data: PropTypes.array,
  url: PropTypes.string,
  fieldClassName: PropTypes.string,
  fieldPlaceholder: PropTypes.string,
  fieldValue: PropTypes.array,
  selectLabel: PropTypes.string,
  selectKey: PropTypes.string
};

export default MultiSelect;
